import { Box } from '@mui/material';
import React, { useCallback, useReducer, useMemo } from 'react';
import { isLocalDev } from '../../../../utils/environment';
import useAbortController from '../../../../hooks/useAbortController';
import EnhancedTable from '../../../enhancedTable/EnhancedTable';
import { creditMemoListColumns } from './columns';
import CreditMemoService from '../../../../service/creditMemoService';

function CreditMemo({ customer }) {
  const [signal] = useAbortController();

  const columns = useMemo(() => creditMemoListColumns, []);

  const [state, updateState] = useReducer((state, params) => {
    return { ...state, ...params };
  }, {
    data: [],
    totalRowCount: 0,
    pageCount: 0,
    filter: '',
    loading: false,
  });

  const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    const from = pageSize * pageIndex;
    
    CreditMemoService.getCreditMemosByCustomerId(customer.customer.id, from, pageSize, filters, sortBy, signal)
      .then(result => {
        const { code, data } = result;
        console.log('Credit Memos fetched:', data);
        if (code === 0) {
          updateState({
            data: data.data,
            totalRowCount: data.count,
            pageCount: Math.ceil(data.count / pageSize),
          });
        }
      })
      .catch(error => {
        if (isLocalDev) {
          console.error(error);
        }
      });
  }, [customer.customer.id, signal]);

  return (
    <Box display="flex" flexDirection="column">
      <EnhancedTable
        columns={columns}
        data={state.data}
        totalRowCount={state.totalRowCount}
        pageCount={state.pageCount}
        fetchData={fetchData}
        loading={state.loading}
        selectionMode="none"
      />
    </Box>
  );
}

export default CreditMemo;
